import React, { useCallback, useState } from 'react';
import { PrimaryActionButton, BackButton, Stack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';
import WizardSpecificPageLinkBottom
  from 'Components/ComponentLibrary/Components/Uncategorized/WizardSpecificPageLinkBottom';
import fr from 'facet-rest';

/* This molecule needs some work with its imports to make it better will be addressed in facet-design-library update */
const WhatIfStepNavigatorWithSpecificLink = ({
  onNext,
  onPrevious,
  children,
  resource,
  handleSpecificPageLink,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const submit = useCallback(async (...args) => {
    try {
      setSubmitting(true);
      await onNext(...args);
      setSubmitting(false);
    } catch (err) {
      setSubmitting(false);
    }
  }, [onNext]);
  if (!(onNext || onPrevious)) {
    return null;
  }

  const specificPageLink = resource.relationship(fr.relationships.specificPageLink.name)?.link('related');

  return (
    <CenteredActions>
      <Stack justifyContent="center" alignItems="flex-start">
        <WizardSpecificPageLinkBottom
          resource={resource}
          onClick={(specificPageLink) ? () => handleSpecificPageLink(specificPageLink) : null}
        />
      </Stack>
      <ActionsRow>
        {onPrevious ? (
          <BackButton
            onClick={onPrevious}
            label="Go Back"
            test={'what-if-stepper-back-button'}
          />
        ) : null}
        {onNext ? (
          <PrimaryActionButton
            onClick={submit}
            loading={submitting}
            disabled={submitting}
            test={'what-if-stepper-continue-button'}
            label={children}
            isFullWidth
            size="lg"
          />
        ) : null}
      </ActionsRow>
    </CenteredActions>
  );
};

WhatIfStepNavigatorWithSpecificLink.defaultProps = {
  onNext: null,
  onPrevious: null,
  children: 'Continue',
};

WhatIfStepNavigatorWithSpecificLink.propTypes = {
  onNext: PropTypes.func,
  onPrevious: PropTypes.func,
  children: PropTypes.node,
  resource: PropTypes.object.isRequired,
  handleSpecificPageLink: PropTypes.func.isRequired,
};

export default WhatIfStepNavigatorWithSpecificLink;
